import Player from "./Player";
import Control from "./Control";

export default {
  name: "ad-view",
  data() {
    return {
      playerEnabled: true
    };
  },
  components: {
    Player,
    Control
  },
  created() {
    this.$store.dispatch("adView/initPendingTasks");
  },
  methods: {
    nextAd() {
      this.playerEnabled = false;
      setTimeout(() => {
        this.playerEnabled = true;
      }, 1000);
    }
  }
};
